import { LatLng, LatLngBounds } from 'leaflet';
import { useEffect, useMemo } from 'react';
import { AONB_Bounds } from '../../application/config';
import { useMap } from 'react-leaflet';
import { Trail } from '../../models/Trail';
import { getTrailPathLatLngs } from './mapPointUtils';

type MapControllerProps = {
	trail: Trail;
};

const cloneAONBBounds = () =>
	new LatLngBounds(AONB_Bounds.getSouthWest(), AONB_Bounds.getNorthEast());

const calcBoundary = (pointList: LatLng[]) => {
	if (pointList.length === 0) {
		return cloneAONBBounds();
	}
	if (pointList.length === 1) {
		const boundary = cloneAONBBounds();
		boundary.extend(pointList[0]);
		return boundary;
	}
	const boundary = new LatLngBounds(pointList[0], pointList[1]);
	for (let listNdx = 2; listNdx < pointList.length; listNdx++) {
		boundary.extend(pointList[listNdx]);
	}
	return boundary;
};

export default function SingleTrailMapController({
	trail,
}: MapControllerProps) {
	const map = useMap();
	const trailPath = useMemo(() => getTrailPathLatLngs(trail), [trail]);

	useEffect(() => {
		try {
			const boundary = calcBoundary(trailPath);
			if (!boundary.isValid()) {
				return;
			}
			map.fitBounds(boundary, {
				padding: [24, 24],
				maxZoom: 15,
			});
		} catch (e) {
			/* ignore fit failures */
		}
	}, [map, trailPath]);

	return null;
}
